import React, { useEffect, useState } from "react";
import Axios from "axios";
import { GetHotListByID} from "../apiconstants/constants";
import { Link, useLocation } from "react-router-dom";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import LoadingSpinner from '../helpers/loadingspinner';
import parse from "html-react-parser"
import DOMPurify from 'dompurify';
import ConsultantLayout from "../commonlayouts/consultantlayout";
function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const ViewHotList = () => {
    let query = useQuery();
    const guid = query.get("guid");
    const data= query.get("data")
 
    const [candidateDetails, setCandidateDetails] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
 const token = localStorage.getItem("jwtToken");
    const GetCandidateDetails = () => {
        setIsLoading(true);
        const GetapiUrl =`${GetHotListByID.APIURL}?hotListID=${data}`;
        Axios.get(GetapiUrl,
            { headers: {   
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            }
          }
        )
            .then((result) => {
                setIsLoading(false);
                setCandidateDetails(result.data[0]);
            })
            .catch((error) => {
                console.error("Error fetching candidate details:", error);
            });
    };
  
    useEffect(() => {
        GetCandidateDetails();
    }, []);

    return (
        <ConsultantLayout>
            {candidateDetails ? (
                < div class="container-fluid">
                <div className='mb-3 mt-3 mr-3'  style={{ display: 'flex', alignItems: 'center' }}>
                        <Link to="/Employer/ListofStaffingContacts">
                            <i className="fa fa-arrow-left mr-3" style={{ color: "#00a7ac", fontSize: 16 }} aria-hidden="true"></i>
                        </Link>
                        <h2 className="" style={{ color: "#00a7ac", marginLeft: '10px', marginBottom: '0', marginTop: '0' }}>Staffing Contact Details</h2>
                    </div>
                    <hr />
                    
                    <div class="card shadow-lg mt-5 p-5" style={{border:"none"}}>
                        
                         <div class="row mt-2">
                   
                    
                    <div class="col-sm-12 col-lg-6 col-xl-6 col-md-6">

                 <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-Name">Name</Tooltip>}>
                        {/* <p className="text-para "><i className="fas fa-user"></i> {candidateDetails.name}</p> */}
                        <p style={{ fontSize: 14, textAlign: 'justify' }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-user" aria-hidden="true"></i> {candidateDetails.name} </p>
                    </OverlayTrigger>
                    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-company">Company</Tooltip>}>
                        {/* <p className="text-para"><i className="fas fa-briefcase"></i> {candidateDetails.company}</p> */}
                        <p style={{ fontSize: 14, textAlign: 'justify' }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-briefcase" aria-hidden="true"></i> {candidateDetails.company} </p>
                    </OverlayTrigger>
                    {candidateDetails.phone !='' &&  candidateDetails.phone != null && candidateDetails.phone!='null' &&   (
                    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-mobileNumber">Phone Number</Tooltip>}>
                    <p style={{ fontSize: 14, textAlign: 'justify' }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fa fa-mobile" aria-hidden="true"></i> {candidateDetails.phone} </p>
                    </OverlayTrigger>)}
                    {candidateDetails.emailId !='' &&  candidateDetails.emailId != null && candidateDetails.emailId!='null' && (
                    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-email">Email</Tooltip>}>
                        <p style={{ fontSize: 14, textAlign: 'justify' }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fa fa-envelope mt-2" aria-hidden="true"></i> {candidateDetails.emailId} </p>
                    </OverlayTrigger>)}
                    {candidateDetails.country !='' &&  candidateDetails.country != null && candidateDetails.country!='null' && ( 
            <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Country</Tooltip>)}>

               <p style={{ fontSize: 14, textAlign: 'justify' }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fa fa-map-marker mt-2" aria-hidden="true"></i> {candidateDetails.country} </p>
            </OverlayTrigger> )}

            {candidateDetails.type !='' &&  candidateDetails.type != null && candidateDetails.type!='null' && ( 
            <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Type</Tooltip>)}>

               <p style={{ fontSize: 14, textAlign: 'justify' }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fa fa-user mt-2" aria-hidden="true"></i> {candidateDetails.type} </p>
            </OverlayTrigger> )}
                    {candidateDetails.website !='' &&  candidateDetails.website != null && candidateDetails.website!='null' && (  
                    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-website">Website URL</Tooltip>}>
                       
                        <p className="text-para"  style={{ fontSize: 14}}>
                       <i style={{ fontSize: 14, color: "#00a7ac", marginRight: 5 }} className="fa fa-globe mt-2" aria-hidden="true"></i>{candidateDetails.website}
           
                       </p>
                    </OverlayTrigger>)}
                   
                    <div className="commenttt-wrapper">
                        
                    {candidateDetails.description !='' &&  candidateDetails.description != null && candidateDetails.description!='null' && (  
                                                            <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-email">Description</Tooltip>}>
                                                            <p style={{ fontSize: 14, textAlign: 'justify' }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fa fa-align-left mt-2" aria-hidden="true"></i> {candidateDetails.description} </p>
                                                              </OverlayTrigger>)}
          </div>

                   
                   
                  </div>
                 </div>
                </div>
</div>
            ) : (
                <center><LoadingSpinner /></center>
            )}
        </ConsultantLayout>
    );
};

export default ViewHotList;
